export default __webpack_public_path__ + "static/media/dragonTiger_1.61d1a704.jpg";